export default __webpack_public_path__ + "static/media/centralair.ef748ba3.jpg";